import { create, skipWhen } from "vest";

import {
  documentIsRequired,
  fileCount,
  fileMax10Mb,
  maxLength,
  nameIsRequired,
  phoneIsValid
} from "utils/validations.utils";

import { FaxFormValues, PATIENT_SOURCE } from "./fax-form.component";

export type FaxFormFieldName =
  | "recipient"
  | "documents"
  | "sender_name"
  | "recipient_name";

export interface DocumentValidatorProps {
  documents: FileList | null;
  include_cover_page: boolean;
  source: string;
}

export const faxFormValidator = () =>
  create((data: FaxFormValues) => {
    const {
      documents,
      recipient,
      source,
      recipient_name,
      sender_name,
      include_cover_page,
      subject
    } = data;

    phoneIsValid<FaxFormFieldName>("recipient", "Fax Number", recipient);
    skipWhen(!include_cover_page, () => {
      nameIsRequired<FaxFormFieldName>(
        "sender_name",
        "Sender Name",
        sender_name
      );
      nameIsRequired<FaxFormFieldName>(
        "recipient_name",
        "Recipient Name",
        recipient_name
      );

      maxLength("subject", "Subject", subject, 55);

      maxLength("sender_name", "Sender Name", sender_name, 40);
      maxLength("recipient_name", "Recipient Name", recipient_name, 40);
    });
    documentIsRequired<FaxFormFieldName>("documents", {
      documents,
      include_cover_page,
      source
    });
    skipWhen(source === PATIENT_SOURCE, () => {
      fileCount<FaxFormFieldName>("documents", "Document", documents);
      fileMax10Mb<FaxFormFieldName>("documents", "Document", documents);
    });
  });
